import React, { Component } from 'react';
import { PageSection, IconCircleExclamation } from 'adc-ui-components';
import { kibanaLog } from '../../helpers/logger';
import isMobilePage from '../../helpers/mobile';
import getConfig from '../../config';
import PageTitle from '../../components/PageTitle';

const { coreCustomerHomepage, mobileHomepage } = getConfig();

class PermsError extends Component {
  componentDidMount() {
    const { error } = this.props;
    kibanaLog(error);
    document.body.classList.add('ui-grey');
  }

  componentWillUnmount() {
    document.body.classList.remove('ui-grey');
  }

  render() {
    const { error } = this.props;
    const isMobile = isMobilePage(window.location.pathname);

    const errorMapping = {
      perms_error: 'As a secondary user, you cannot access restricted areas of My Account',
    };

    const friendlyError = errorMapping[error];

    return (
      <PageSection className="ui-grey page-section--banner">
        <IconCircleExclamation className="mb6 svg-icon--42" />

        <div className="hgroup">
          <PageTitle>Restricted Section</PageTitle>
          {friendlyError && <p>{friendlyError}</p>}
        </div>
        <a
          className="button button--primary"
          href={isMobile ? mobileHomepage : coreCustomerHomepage}
        >
          Back to My Account
        </a>
      </PageSection>
    );
  }
}

export default PermsError;
